const locales = {
    et: 'EST',
    en: 'ENG',
};

const transformTemplate = (template) => {
    return {
        id: template.id,
        name: template.title,
        type: template.ext_id === 'all' ? 'system' : 'custom',
        description: template.description || '',
        locale: locales[template.locale] || locales.en,
    };
};

export default {
    transform(templates) {
        if (!Array.isArray(templates)) {
            return [];
        }
        const result = [];
        templates.forEach(template => {
            result.push( transformTemplate(template) );
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/transformers/input/contract-templates/index.js